var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ingame-popup-wrap" }, [
    _c("div", { staticClass: "ingame-popup", class: { active: _vm.show } }, [
      _c("p", { staticClass: "popup-title" }, [
        _vm._v(_vm._s(_vm.$t("title_purchase_complete"))),
      ]),
      _c("p", { staticClass: "text-box" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("text_purchase_complete")))]),
      ]),
      _c("div", { staticClass: "ingame-popup-bottom" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-completed",
            attrs: { href: "javascript:;" },
            on: { click: _vm.close },
          },
          [_vm._v(_vm._s(_vm.$t("btn_completed")))]
        ),
      ]),
      _c("a", {
        staticClass: "btn-close",
        attrs: { href: "javascript:;" },
        on: { click: _vm.close },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }